<template>
  <div
    :class="[
      'home-banner',
      { 'placeholder-padding': !sliderList.length },
      `${sliderStyle}`,
      `${page_style || ''}`,
      `${positionStyle}`
    ]"
  >
    <swiper v-if="sliderList.length" :class="sliderStyle">
      <swiper-slider v-for="(item, idx) in sliderList" :key="idx">
        <div class="banner-item lapping" v-if="sliderStyle === 'h5_global'">
          <img-v3 :src="item.icon_url" alt="" class="banner-item-logo" />
          <div class="banner-item-title">
            {{ item.title }}
          </div>
          <div class="banner-item-subTitle">
            {{ item.sub_title }}
          </div>
        </div>
        <div class="banner-item whatsapp" v-if="sliderStyle === 'whatsapp'">
          <img-v3 :src="item.background_img_url" alt="" class="banner-item-bg" />
          <!-- <div class="banner-item-title">
            {{ item.title }}
          </div> -->
          <div class="banner-item-subTitle">
            {{ item.sub_title }}
          </div>
        </div>
        <div class="banner-item" v-if="sliderStyle === 'h5_au'">
          <img-v3 :src="item.background_img_url" alt="" class="banner-item-bg" />
        </div>
        <div
          :class="['banner-item', 'h5_br', {'h5_funnel': isNewFunnel}]"
          v-if="isNewLandingpage || isNewFunnel"
          @click="goLink(item)"
          :style="{
              background: `url(${getWebpImg(item.background_img_url)}) 0% 0% / cover no-repeat`,
          }">
          <div class="banner-item-title"
            :style="{
                color: item.text_color
            }">
            {{ item.title }}
          </div>
          <div class="banner-item-subTitle"
            :style="{
                color: item.text_color
            }">
            {{ item.sub_title }}
          </div>
        </div>
      </swiper-slider>
    </swiper>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { post } from "../../tools/request";
import { Swiper, SwiperSlider } from "../base/Swiper";
import { goThirdLink } from "../../tools/utils";
import { getImageResizeUrl } from "@didi/webcube";

export default {
  // "formItem"
  props: ["formItem", "omegaItem", "page_style", "position_style"],
  data() {
    return {
      citySliderList: null
    };
  },
  mounted() {
    // console.log(this.formItem)
  },
  watch: {
    _area: {
      handler(newV, oldV) {
        if (newV.value && this.formItem.refresh_url) {
          this.getBannerList()
        }
      },
      deep: true,
      immediate: true, //页面初始化时立即调用
    },
  },
  computed: {
    ...mapState(["_area"]),
    sliderList() {
      return this.citySliderList || this.formItem.img || [];
    },
    sliderStyle() {
      return this.formItem.style || "h5_global";
    },
    positionStyle() {
      return this.position_style || ''
    },
    isNewLandingpage() {
      return ['h5_br'].includes(this.sliderStyle);
    },
    isNewFunnel() {
      return ["h5_funnel", "h5_funnel_fleet", "h5_funnel_fleet_pc"].includes(this.sliderStyle);
    },
  },
  methods: {
    getWebpImg(url) {
      console.log('getWebpImg', getImageResizeUrl(url, true))
      return getImageResizeUrl(url, true)
    },
    goLink(item) {
      Omega.trackEvent("ibt_onboarding_landingpageclickbanner_ck", "", this.omegaItem);
      if (!item.link) {
        return
      }

      let up = new URLSearchParams(location.search);
      if (this._area.value && this._area.text) {
          up.set("areaId", this._area.value);
          up.set("areaName", this._area.text);
      }
      goThirdLink({
        up,
        url: item.link,
        target: item.link_type || item.target
      })
    },
    getBannerList() {
      let up = new URLSearchParams(location.search);
      up.set('area_id', this._area.value)
      post(this.formItem.refresh_url, up)
        .then(res => {
          this.citySliderList = res.img || null
          console.log(res)
        })
        .catch(res => {
          this.citySliderList = null
        });
    }
  },
  components: {
    Swiper,
    SwiperSlider,
  },
};
</script>
<style lang="scss" scoped>
.home-banner {
  margin-bottom: 0.8rem;
  &.h5_global {
    background-image: linear-gradient(-135deg, #fe7947 0%, #ffb984 100%);
  }
  &.placeholder-padding {
    padding-top: 60%;
  }
  &.h5_br {
    margin-bottom: 0;
    background-image: transparent;
  }
  &.h5_funnel {
    margin-bottom: 0.64rem;
  }
  &.h5_funnel_fleet {
    margin-bottom: 0.32rem;
  }
  &.h5_funnel_fleet_pc {
    margin-bottom: 0;
  }
  .banner-item {
    &.lapping {
      padding: 0.64rem;
      color: #fff;
    }
    text-align: center;
    .banner-item-bg {
      position: relative;
      width: 100%;
    }
    .banner-item-logo {
      margin: 0 auto 0.48rem;
      max-width: 0.82rem;
      max-height: 0.82rem;
    }
    .banner-item-title {
      margin-bottom: 0.48rem;
      font-size: 0.44rem;
      font-weight: 700;
    }
    .banner-item-subTitle {
      margin-bottom: 0.48rem;
      font-size: 0.32rem;
      line-height: 1.2;
    }
    &.whatsapp {
      .banner-item-title {
        position: absolute;
        top: 0.48rem;
        left: 0;
        right: 0;
        margin: 0 auto;
        font-size: 0.48rem;
      }
      .banner-item-subTitle {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 1.1rem;
        margin: 0 auto;
      }
    }
    &.h5_br {
      height: 5rem;
      padding-left: 0.48rem;
      padding-top: 0.84rem;
      box-sizing: border-box;
      color: #fff;
      .banner-item-title,
      .banner-item-subTitle {
        width: 50%;
        text-align: left;
      }
    }
    &.h5_funnel {
      height: 2.6rem;
      padding: 0.32rem;
      .banner-item-title {
        margin-bottom: 0.06rem;
        font-size: .36rem;
        font-weight: 700;
        line-height: 0.44rem;
      }
      .banner-item-subTitle {
        font-size: .24rem;
        font-weight: 400;
        line-height: 0.3rem;
      }
      .banner-item-title,
      .banner-item-subTitle {
        width: 67%;
        color: #333333;
      }
    }
  }
  &.h5_funnel_fleet_pc.inside_rotation_banner {
    margin-bottom: 64px;
    .banner-item {
      height: 140px;
      border-radius: 6px;
    }
  }
}
</style>


